import React from "react";
import { motion } from "framer-motion";
import { Truck, Layers, Ruler, ShieldCheck } from "lucide-react";

const FEATURES = [
  { icon: Truck, title: "FREE SHIPPING", sub: "ON ORDERS OVER $99" },
  { icon: Layers, title: "PREMIUM FABRIC", sub: "BUILT TO PERFORM" },
  { icon: Ruler, title: "ENGINEERED FIT", sub: "MADE TO MOVE" },
  { icon: ShieldCheck, title: "LIFETIME BRAND", sub: "BUILT ON PURPOSE" },
];

export const Features = () => (
  <section data-testid="features" className="relative bg-[#080808] border-y border-white/10">
    <div className="mx-auto max-w-[1600px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      {FEATURES.map((f, i) => {
        const Icon = f.icon;
        return (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
            className="group flex flex-col items-center text-center gap-4 px-8 py-14 border-white/10 [&:not(:last-child)]:lg:border-r [&:not(:last-child)]:sm:border-b lg:[&:not(:last-child)]:border-b-0"
          >
            <Icon className="w-8 h-8 text-white/60 group-hover:text-white transition-colors duration-500" strokeWidth={1.2} />
            <div>
              <h3 className="font-display font-bold tracking-[0.12em] text-lg text-white">{f.title}</h3>
              <p className="font-sans text-[10px] tracking-[0.25em] text-white/40 mt-1">{f.sub}</p>
            </div>
          </motion.div>
        );
      })}
    </div>
  </section>
);

export default Features;
